/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/st_geotile.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Calculates the `geotile` of the supplied geo_point at the specified precision.
 * The result is long encoded.
 * Use `TO_STRING`
 * to convert the result to a string,
 * `TO_LONG`
 * to convert it to a `long`, or
 * `TO_GEOSHAPE`
 * to calculate the `geo_shape` bounding geometry.
 *
 * These functions are related to the `geo_grid` query
 * and the `geotile_grid` aggregation.
 *
 * @example
 * FROM airports
 * | EVAL geotile = ST_GEOTILE(location, 2)
 * | STATS
 *     count = COUNT(geotile),
 *     centroid = ST_CENTROID_AGG(location)
 *       BY geotile
 * | EVAL geotileString = TO_STRING(geotile)
 * | SORT count DESC, geotileString ASC
 * | KEEP count, centroid, geotileString
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'st_geotile',
  signatures: [
    {
      params: [
        {
          name: 'geometry',
          type: 'geo_point',
          optional: false,
        },
        {
          name: 'precision',
          type: 'integer',
          optional: false,
          hint: {
            kind: 'constant',
          },
        },
      ],
      variadic: false,
      returnType: 'geotile',
    },
    {
      params: [
        {
          name: 'geometry',
          type: 'geo_point',
          optional: false,
        },
        {
          name: 'precision',
          type: 'integer',
          optional: false,
          hint: {
            kind: 'constant',
          },
        },
        {
          name: 'bounds',
          type: 'geo_shape',
          optional: true,
          hint: {
            kind: 'constant',
          },
        },
      ],
      variadic: false,
      returnType: 'geotile',
    },
  ],
  preview: true,
  snapshotOnly: false,
};

export default definition;
